import React, { useState, useEffect } from "react";
import axios from "axios";
import { FetchMedia } from '../../hooks/APIHooks';

const MediaManager = () => {
  const [mediaFiles, setMediaFiles] = useState([]);
  const [selectedFile, setSelectedFile] = useState(null);
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState("");

  useEffect(() => {
    fetchMediaFiles();
  }, []);

  // Fetch all media files
  const fetchMediaFiles = async () => {
    try {
      const response = await axios.get(FetchMedia);
      setMediaFiles(response.data.files); // Adjusted to match the response structure
    } catch (error) {
      console.error("Error fetching media files:", error);
    }
  };

  // Handle file selection
  const handleFileChange = (e) => {
    setSelectedFile(e.target.files[0]);
  };

  // Upload media file
  const handleUpload = async (e) => {
    e.preventDefault();
    if (!selectedFile) return;

    setLoading(true);
    setMessage("");

    const formData = new FormData();
    formData.append("media_file", selectedFile);

    try {
      const response = await axios.post(FetchMedia, formData, {
        headers: { "Content-Type": "multipart/form-data" },
      });

      if (response.data.success) {
        fetchMediaFiles();
        setMessage(response.data.message);
      } else {
        setMessage(response.data.message);
      }
    } catch (error) {
      setMessage("Upload failed");
    } finally {
      setLoading(false);
    }
  };

  // Delete a media file
  const handleDelete = async (fileName) => {
    if (!window.confirm("Are you sure you want to delete this file?")) return;

    setLoading(true);
    setMessage("");

    try {
      const response = await axios.delete(FetchMedia, {
        data: { file_name: fileName },
      });

      if (response.data.success) {
        fetchMediaFiles();
      } else {
        setMessage(response.data.message);
      }
    } catch (error) {
      setMessage("Deletion failed");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="container mx-auto p-5">
      <h1 className="text-2xl font-bold mb-4">Product Media Manager</h1>

      {/* Upload Section */}
      <form onSubmit={handleUpload} className="mb-4">
        <input type="file" onChange={handleFileChange} className="border p-2" accept="image/*" required />
        <button type="submit" className="bg-blue-500 text-white px-4 py-2 ml-2" disabled={loading}>
          {loading ? "Uploading..." : "Upload"}
        </button>
      </form>

      {message && <p className="text-red-500">{message}</p>}

      {/* Image Gallery */}
      <div className="grid grid-cols-2 md:grid-cols-4 gap-4">
        {mediaFiles.length > 0 ? (
          mediaFiles.map((file) => (
            <div key={file.id} className="border p-3 rounded">
              <img src={file.file_path} alt={file.file_name} className="w-full h-40 object-cover rounded" />
              <p className="text-center mt-2">{file.file_name}</p>
              <button
                onClick={() => handleDelete(file.file_name)}
                className="bg-red-500 text-white px-3 py-1 w-full mt-2"
                disabled={loading}
              >
                Delete
              </button>
            </div>
          ))
        ) : (
          <p className="text-center col-span-4">No images found</p>
        )}
      </div>
    </div>
  );
};

export default MediaManager;
